export default __webpack_public_path__ + "static/media/beliveClosed.e21254f3.jpg";